import * as numbers from "common/numbers";

const validPattern = /^-?[0-9, ]*\.?[0-9, ]*(e[0-9]+)?[kKmMbBtT]?$/;

const _getMultiplicand = (lastChar) => {
  switch (lastChar) {
    case "k":
      return 1e3;
    case "m":
      return 1e6;
    case "b":
      return 1e9;
    case "t":
      return 1e12;
    default:
      return 1;
  }
};

const _parseNumberString = (str) => {
  if (str === "") {
    return null;
  }
  if (!validPattern.exec(str)) {
    return NaN;
  }
  str = str.replace(/[ ,]/g, "");
  const parsedFloat = parseFloat(str);
  const multiplicand = _getMultiplicand(str.slice(-1).toLowerCase());

  if (!isNaN(parsedFloat)) {
    return parsedFloat * multiplicand;
  }
  return NaN;
};

export const parseNumberString = (str) => {
  if (str === "") {
    return null;
  }
  const value = _parseNumberString(str);
  return isNaN(value) ? numbers.parseNumberString(str) ?? NaN : value;
};
